/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_APPLICATION_ID_DETAILS_REQUEST,
  FETCH_APPLICATION_ID_DETAILS_SUCCESS,
  FETCH_APPLICATION_ID_DETAILS_FAILURE,
} from "./AppIdDetailsTypes";

const initialState = {
  loading: false,
  applicationDetails: {},
  error: "",
};

const applicationidDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPLICATION_ID_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_APPLICATION_ID_DETAILS_SUCCESS:
      return {
        loading: false,
        applicationDetails: action.payload,
        error: "",
      };
    case FETCH_APPLICATION_ID_DETAILS_FAILURE:
      return {
        loading: false,
        applicationDetails: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default applicationidDetailsReducer;
